module.exports = __webpack_public_path__ + "media/images/athletes/901-986ecc47c83b1eb009607bb7e68209be.png";